import React, { Component } from 'react';
import axios from "axios";
import {NotificationManager} from 'react-notifications';
import {login} from '../../utils/index'
import store, {CART_COUNT_UPDATE} from '../../utils/store';

class Signinotp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step:'mobile',
            mobile_number:'',
            otpDigits:['', '', '', '', '', ''],
            resendCountdown:0,
            isSendingOtp:false,
            isVerifyingOtp:false,
            serviceCheck:false,
        };
        this.otpInputRefs = [];
        this.resendTimer = null;
    }

    componentDidMount() {
        this.clearResendTimer();
    }

    componentWillUnmount() {
        this.clearResendTimer();
    }

    clearResendTimer() {
        if (this.resendTimer) {
            clearInterval(this.resendTimer);
            this.resendTimer = null;
        }
    }

    startResendTimer(duration = 60) {
        this.clearResendTimer();
        this.setState({resendCountdown: duration});
        this.resendTimer = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.resendCountdown <= 1) {
                    this.clearResendTimer();
                    return {resendCountdown: 0};
                }
                return {resendCountdown: prevState.resendCountdown - 1};
            });
        }, 1000);
    }

    isValidMobileNumber() {
        return /^\d{10}$/.test(this.state.mobile_number);
    }

    getOtpValue() {
        return this.state.otpDigits.join('');
    }

    maskMobileNumber(number) {
        if (!number || number.length < 4) {
            return 'your mobile number';
        }

        return `••••••${number.slice(-4)}`;
    }

    formatCountdown(seconds) {
        const safeSeconds = Math.max(0, seconds);
        const minutes = String(Math.floor(safeSeconds / 60)).padStart(2, '0');
        const remainingSeconds = String(safeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainingSeconds}`;
    }

    isOtpComplete() {
        return /^\d{6}$/.test(this.getOtpValue());
    }

    focusOtpIndex(index) {
        if (this.otpInputRefs[index]) {
            this.otpInputRefs[index].focus();
        }
    }

    async handlePrimaryAction() {
        if (this.state.step === 'mobile') {
            await this.getOTP();
        } else {
            await this.submitsigninotp();
        }
    }

    async submitsigninotp(){

        const { mobile_number }  = this.state;
        const mobile_otp = this.getOtpValue();

        if(!this.isValidMobileNumber()) {
            NotificationManager.error('Please enter the valid mobile number');
        }else if(!this.isOtpComplete()) {
            NotificationManager.error('Please enter the mobile OTP');
        }else{

          const params = new URLSearchParams();
          params.append('mobile_number', mobile_number);
          params.append('mobile_otp', mobile_otp);
            try {
                this.setState({isVerifyingOtp:true, otp_error:''});
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/loginviaotp',params);
                let resVal=response.data;
                if(resVal.status === 'success'){
                    login(resVal.token);
                    store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount});
                    localStorage.setItem('BYOS_UserName',resVal.username);
                    NotificationManager.success(resVal.message);
                    window.scrollTo(0, 0);
                    this.props.history.push('/');
                }else{
                    NotificationManager.error(resVal.message);
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.setState({isVerifyingOtp:false});
            }

        }
    }


    async getOTP(){
        const { mobile_number }  = this.state ;
        if(this.isValidMobileNumber()){
            try {
                const params = new URLSearchParams();
                params.append('mobile_number', mobile_number);
                this.setState({isSendingOtp:true, otp_error:''});
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/sendOTPforOtpLogin', params);
                let resVal=response.data;
                if(resVal.status === 'success'){
                    NotificationManager.success(resVal.message);
                    this.setState({
                        step:'otp',
                        otpDigits:['', '', '', '', '', ''],
                    }, () => {
                        this.startResendTimer(60);
                        this.focusOtpIndex(0);
                    });
                }else{
                    NotificationManager.error(resVal.message);
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.setState({isSendingOtp:false});
            }

        }else{
            NotificationManager.error('Invalid mobile number');
        }
    }


    async resendOTP(){
        if(this.state.resendCountdown > 0) {
            return;
        }
        await this.getOTP();
    }

    handleBack = () => {
        this.clearResendTimer();
        this.setState({
            step:'mobile',
            otpDigits:['', '', '', '', '', ''],
            resendCountdown:0,
        }, () => {
            this.focusOtpIndex(0);
        });
    }

    handleMobileChange(event) {
        const value = event.target.value.replace(/\D/g, '').slice(0, 10);
        this.setState({mobile_number:value});
    }

    handleOtpChange(index, event) {
        const rawValue = event.target.value.replace(/\D/g, '');
        const value = rawValue.slice(-1);

        this.setState((prevState) => {
            const otpDigits = [...prevState.otpDigits];
            otpDigits[index] = value;
            return {otpDigits};
        }, () => {
            if (value && index < 5) {
                this.focusOtpIndex(index + 1);
            }
        });
    }

    handleOtpKeyDown(index, event) {
        if (event.key === 'Backspace' && !this.state.otpDigits[index] && index > 0) {
            this.focusOtpIndex(index - 1);
        }
        if (event.key === 'ArrowLeft' && index > 0) {
            this.focusOtpIndex(index - 1);
        }
        if (event.key === 'ArrowRight' && index < 5) {
            this.focusOtpIndex(index + 1);
        }
    }

    handleOtpPaste(event) {
        const pastedValue = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        if (!pastedValue) {
            return;
        }
        event.preventDefault();
        const otpDigits = Array.from({length: 6}, (_, index) => pastedValue[index] || '');
        this.setState({otpDigits}, () => {
            const nextIndex = Math.min(pastedValue.length, 5);
            this.focusOtpIndex(nextIndex);
        });
    }

    storeState(elementName,event) {
        if(elementName === 'mobile_number'){
            this.handleMobileChange(event);
        }
    }

    render() {

        const { step, mobile_number, otpDigits, resendCountdown, isSendingOtp, isVerifyingOtp }  = this.state ;
        const primaryDisabled = step === 'mobile'
            ? !this.isValidMobileNumber() || isSendingOtp
            : !this.isOtpComplete() || isVerifyingOtp;
        return (
            <>
                <div className={`auth-otp auth-otp--${step}`}>
                    <div className="auth-otp__stepper">
                        <div className="auth-otp__step-item auth-otp__step-item--active">
                            <span className={`auth-otp__step ${step === 'mobile' || this.isValidMobileNumber() ? 'auth-otp__step--active' : ''}`}>1</span>
                            <div className="auth-otp__step-copy">
                                <strong>Mobile number</strong>
                                <small>Enter your registered number</small>
                            </div>
                        </div>
                        <div className="auth-otp__stepper-line" aria-hidden="true">
                            <span className={`auth-otp__stepper-fill ${step === 'otp' ? 'auth-otp__stepper-fill--active' : ''}`} />
                        </div>
                        <div className={`auth-otp__step-item ${step === 'otp' ? 'auth-otp__step-item--active' : ''}`}>
                            <span className={`auth-otp__step ${step === 'otp' ? 'auth-otp__step--active' : ''}`}>2</span>
                            <div className="auth-otp__step-copy">
                                <strong>Verify OTP</strong>
                                <small>Enter the 6 digit code</small>
                            </div>
                        </div>
                    </div>

                    <div className="auth-otp__fields">
                        <div className="auth-otp__field">
                            <div className="auth-otp__field-head">
                                <label className="auth-otp__label">{step === 'mobile' ? 'Mobile number' : 'Verify OTP'}</label>
                                {step === 'otp' ? (
                                    <button className="auth-otp__back" type="button" onClick={this.handleBack}>
                                        Back
                                    </button>
                                ) : null}
                            </div>
                            {step === 'mobile' ? (
                                <div className="auth-otp__input-row">
                                    <input
                                        className="auth-otp__input"
                                        name="mobile_number"
                                        placeholder="Enter your 10 digit number"
                                        maxLength="10"
                                        type="text"
                                        inputMode="numeric"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck={false}
                                        autoSave="off"
                                        value={mobile_number}
                                        onChange={(event)=>this.storeState('mobile_number',event)}
                                    />
                                </div>
                            ) : (
                                <div className="auth-otp__summaryBox">
                                    <span className="auth-otp__summaryLabel">OTP sent to</span>
                                    <strong className="auth-otp__summaryValue">{this.maskMobileNumber(mobile_number)}</strong>
                                    <span className="auth-otp__summaryNote">Use the 6 digit code sent to this number.</span>
                                </div>
                            )}
                            <p className="auth-otp__hint">
                                {step === 'mobile'
                                    ? 'Use the same number linked to your account.'
                                    : 'Enter the 6 digit code sent to your mobile number.'}
                            </p>
                        </div>

                        {step === 'otp' ? (
                            <div className="auth-otp__field">
                                <div className="auth-otp__resend-card">
                                    <div className="auth-otp__resend-copy">
                                        <span className="auth-otp__resend-label">Need another code?</span>
                                        <span className="auth-otp__resend-note">
                                            {resendCountdown > 0
                                                ? `Resend available in ${this.formatCountdown(resendCountdown)}`
                                                : 'You can request a new OTP right away.'}
                                        </span>
                                    </div>
                                    <div className="auth-otp__resend-action">
                                        <button
                                            className="auth-otp__resend"
                                            type="button"
                                            onClick={()=>this.resendOTP()}
                                            disabled={resendCountdown > 0 || isSendingOtp}
                                        >
                                            Resend OTP
                                        </button>
                                        <span className="auth-otp__resend-support">
                                            {resendCountdown > 0
                                                ? 'Please wait for the timer to finish.'
                                                : 'Tap to get a new code.'}
                                        </span>
                                    </div>
                                </div>
                                <div className="auth-otp__code-row" onPaste={(event)=>this.handleOtpPaste(event)}>
                                    {otpDigits.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => { this.otpInputRefs[index] = el; }}
                                            className="auth-otp__code-box"
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength="1"
                                            aria-label={`OTP digit ${index + 1}`}
                                            value={digit}
                                            onChange={(event)=>this.handleOtpChange(index, event)}
                                            onKeyDown={(event)=>this.handleOtpKeyDown(index, event)}
                                        />
                                    ))}
                                </div>
                            </div>
                        ) : null }
                    </div>

                    <div className="auth-otp__submit">
                        <button
                            className="ps-btn ps-btn--warning auth-otp__submit-btn"
                            type="button"
                            onClick={()=>this.handlePrimaryAction()}
                            disabled={primaryDisabled}
                        >
                            {step === 'mobile' ? (isSendingOtp ? 'Sending OTP...' : 'Continue') : (isVerifyingOtp ? 'Verifying...' : 'Continue')}
                        </button>
                        <div className="auth-otp__secure-note">
                            Protected login for your Natureway account.
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default Signinotp;
